'use client'

import React, { Suspense } from 'react'

// import { RenderBlocks } from '@/blocks/RenderBlocks'
import { FormBlock } from '@/blocks/Form/Component'
import { Media } from '@/components/Media'
import { RevealSection } from '@/components/RevealSection'
import RichText from '@/components/RichText'
import { useLenisContext } from '@/providers/Lenis'

import type { FormColumns as FormColumnsType } from '@/payload-types'
import type { Form as FormType } from '@payloadcms/plugin-form-builder/types'

const FormBlockWrapper: React.FC<{ form: FormType }> = (props) => {
  const { form } = props

  return (
    <div className="mt-6 w-full self-start rounded-2xl border border-border bg-neutral-100 px-4 py-6 xs:px-6 lg:mt-0 lg:p-8 xl:p-10 [&>div]:m-0">
      <Suspense fallback={<></>}>
        <FormBlock
          blockType="formBlock"
          enableIntro={false}
          form={form}
          formDrawer={false}
          className="m-0! w-full border-none bg-inherit p-0! shadow-none"
        />
      </Suspense>
    </div>
  )
}

export const FormColumnsBlockClient: React.FC<FormColumnsType> = (props) => {
  const { heading, subtitle, form, formImage } = props
  const { isMobile } = useLenisContext()

  const formPopulated = form && typeof form === 'object' && 'id' in form && 'title' in form

  return (
    <div className="relative z-10 wrapper md:py-16">
      <div className="flex flex-col gap-6 lg:flex-row lg:gap-12">
        <RevealSection stagger staggerDelay={0.1} className="flex-1 lg:max-w-[50%]">
          <h2 className="mb-6 block font-family-display text-3xl font-normal text-balance text-foreground md:text-5xl">
            {heading}
          </h2>
          {subtitle && (
            <div className="flex-1">
              <RichText
                data={subtitle}
                enableGutter={false}
                className="mx-0 text-lg font-medium text-balance whitespace-pre-line text-secondary-foreground md:pr-12 md:text-2xl"
              />
            </div>
          )}
          {formPopulated && isMobile && <FormBlockWrapper form={form as unknown as FormType} />}
          {formImage && (
            <div className="mt-10 w-full max-w-100 flex-1 max-lg:hidden">
              <Media
                resource={formImage}
                context={'thumbnail'}
                className="size-full object-cover object-center"
              />
            </div>
          )}
        </RevealSection>
        {formPopulated && !isMobile && (
          <RevealSection
            delay={0.3}
            direction="left"
            distance={60}
            className="relative z-20 w-full flex-1 lg:sticky lg:top-20 lg:max-w-[50%]"
          >
            <FormBlockWrapper form={form as unknown as FormType} />
          </RevealSection>
        )}
      </div>
    </div>
  )
}
